import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import ClientPurchaseOrderCrud from "../../organisms/CPO/ClientPurchaseOrderCrud";
import CPOGanttChart from "../../organisms/CPO/CPOGanttChart";
import OperationProcessCrud from "../../organisms/OperationProcess/OperationProcessCrud";
import DashboardLayout from "../../layouts/DashboardLayout";
import { LGTabPanel } from "../../molecules/LGTabPanel";
import { useCompany } from "../../contexts/CompanyContext";
import { getUserRoles } from "../../services/auth";

const ClientPurchaseOrderScreen = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompany } = useCompany();
  const { roles } = getUserRoles();
  const isSuperadmin = roles.includes("Superadmin");

  const handleChange = (_event, newValue) => {
    setActiveTab(newValue);
  };

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una compañía primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label={`Órdenes ${selectedCompany.name}`} />
          <Tab label="Gantt" />
          {isSuperadmin && <Tab label="Procesos de Operación" />}
        </Tabs>
      </Box>

      <LGTabPanel value={activeTab} index={0}>
        <ClientPurchaseOrderCrud companyId={selectedCompany.id} />
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={1}>
        <CPOGanttChart companyId={selectedCompany.id} />
      </LGTabPanel>

      {isSuperadmin && (
        <LGTabPanel value={activeTab} index={2}>
          <OperationProcessCrud companyId={selectedCompany.id} />
        </LGTabPanel>
      )}
    </DashboardLayout>
  );
};

export default ClientPurchaseOrderScreen;
